module.exports = __webpack_public_path__ + "img/Gallery_1_20.8b1913a2.jpeg";